// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as DOMPurify$LiveRoom from "../bindings/DOMPurify.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as AnimateHeight$LiveRoom from "../bindings/AnimateHeight.bs.js";
import * as SterlingIcons$LiveRoom from "../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function CollapsibleTextBlock(props) {
  var gated = props.gated;
  var onToggle = props.onToggle;
  var blockInitiallyOpen = props.blockInitiallyOpen;
  var blockInitiallyOpen$1 = blockInitiallyOpen !== undefined ? blockInitiallyOpen : false;
  var gated$1 = gated !== undefined ? gated : false;
  var match = React.useState(function () {
        return blockInitiallyOpen$1;
      });
  var setIsOpen = match[1];
  var isOpen = match[0];
  return React.createElement(React.Fragment, undefined, React.createElement("button", {
                  "aria-expanded": isOpen,
                  className: Curry._1(Css.style, {
                        hd: Css.display(Css.flexBox),
                        tl: {
                          hd: Css.justifyContent(Css.spaceBetween),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: {
                              hd: Css.width(Css.pct(100)),
                              tl: {
                                hd: Css.background("transparent"),
                                tl: {
                                  hd: Css.border("zero", "none", "transparent"),
                                  tl: {
                                    hd: Css.padding("zero"),
                                    tl: {
                                      hd: Css.focus(CommonStyles$LiveRoom.buttonFocus),
                                      tl: {
                                        hd: Css.hover({
                                              hd: Css.cursor("pointer"),
                                              tl: /* [] */0
                                            }),
                                        tl: {
                                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }),
                  onClick: (function (param) {
                      if (gated$1) {
                        return Curry._1(onToggle, true);
                      } else {
                        Curry._1(setIsOpen, (function (param) {
                                return !isOpen;
                              }));
                        return Curry._1(onToggle, !isOpen);
                      }
                    })
                }, React.createElement(SterlingTypography$LiveRoom.Label18Medium.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.important(Css.fontWeight({
                                      NAME: "num",
                                      VAL: 600
                                    })),
                            tl: {
                              hd: Css.textTransform("capitalize"),
                              tl: {
                                hd: Css.marginTop(Css.px(16)),
                                tl: {
                                  hd: Css.marginBottom(Css.px(8)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }),
                      children: props.title
                    }), React.createElement("div", undefined, React.createElement(SterlingIcons$LiveRoom.Collection.Minus24.make, {
                          className: Curry._1(Css.style, {
                                hd: Css.marginRight(Css.px(-24)),
                                tl: /* [] */0
                              })
                        }), React.createElement(SterlingIcons$LiveRoom.Collection.Minus24.make, {
                          className: Curry._1(Css.style, {
                                hd: Css.transition(StyleConstants$LiveRoom.animationMedium, undefined, undefined, "transform"),
                                tl: {
                                  hd: Css.transform({
                                        NAME: "rotate",
                                        VAL: Css.deg(isOpen ? 0 : 90)
                                      }),
                                  tl: /* [] */0
                                }
                              })
                        }))), React.createElement(AnimateHeight$LiveRoom.make, {
                  visibility: isOpen ? "visible" : "hidden",
                  duration: StyleConstants$LiveRoom.animationFastInt,
                  children: React.createElement("div", {
                        className: Curry._1(Css.merge, {
                              hd: CommonStyles$LiveRoom.htmlContentStyle(16, 24),
                              tl: {
                                hd: Curry._1(Css.style, {
                                      hd: Css.marginTop(Css.px(16)),
                                      tl: {
                                        hd: Css.whiteSpace("preWrap"),
                                        tl: {
                                          hd: Css.wordBreak(Css.breakAll),
                                          tl: /* [] */0
                                        }
                                      }
                                    }),
                                tl: /* [] */0
                              }
                            }),
                        dangerouslySetInnerHTML: {
                          __html: DOMPurify$LiveRoom.sanitize(props.contentText)
                        }
                      })
                }));
}

var make = CollapsibleTextBlock;

export {
  make ,
}
/* Css Not a pure module */
